<template>
  <!--合同显示-->
  <div
    class="contract-view"
    ref="bigBox"
    @drop="dropData($event)"
    @dragover="
      $event => {
        $event.preventDefault();
      }
    "
    v-loading="imgLoading"
    @mousedown.prevent="pageMousedown($event)"
    @mouseleave="pageLeave($event)"
  >
    <el-slider
      class="slider-bar"
      :value="scaleValue"
      @input="
        val => {
          this.$emit('update:scaleValue', val);
        }
      "
      :step="5"
      :min="50"
      :max="200"
      show-input
    >
    </el-slider>
    <!--放大镜小图容器-->
    <div v-if="showSmallBox" class="small-box">
      <div
        @mouseup="handleMoveStop"
        @mouseleave="handleMoveStop"
        @mousedown="handleMoveMousedown"
        class="float-box"
      ></div>
      <img v-if="url" :src="url" />
      <img v-else :src="contractInfo.url" />
    </div>

    <!--放大镜大图容器-->
    <div
      v-if="url || contractInfo"
      class="big-box"
      :style="`transform:scale(${scaleValue / 100});`"
    >
      <!--合同容器-->
      <div class="cont-box" ref="contBox">
        <!--页码-->
        <p class="text-center page-shwo">{{ page }}/{{ items }}</p>
        <img
          class="imgInfo"
          @load="handleImgLoad"
          @error="imgLoading = false"
          v-if="url"
          :src="url"
          :key="page"
          alt="合同信息"
        />
        <img
          class="imgInfo"
          @load="handleImgLoad"
          @error="imgLoading = false"
          v-else
          :src="contractInfo.url"
          :key="page"
          alt="合同信息"
        />
        <!--章显示-->
        <div v-if="showChapter && chapterList.length" class="chapter-list">
          <template v-for="item in chapterList">
            <div
              v-if="(item._page ? item._page === page - 1 : item.page === page - 1)"
              :key="item.cindex"
              class="cachet-box"
              :style="handleSetChapte(item)"
              :data-cindex="item.cindex"
            >
              <template v-if="item.url">
                <!-- 现在版自定义样式 -->
                <div
                  v-if="isCreate"
                  :class="{
                    'qz-new': true,
                    draging: cachetMove && currentIndex === item.cindex
                  }"
                >
                  <a
                    @click="delChapter(item.cindex)"
                    href="javascript:void (0)"
                    class="el-icon-error color-danger del-chapter del-chapter__sign"
                  ></a>
                  <div
                    @mousedown.capture="
                      handleCacheMousedown($event, item.cindex)
                    "
                  >
                    <h1 :style="{background:[undefined,null].includes(item.batch) ? '#ffa7a7':'#e6cc75'}">{{ item.signOwner }}</h1>
                    <div class="con" :style="{borderColor: [undefined,null].includes(item.batch) ? '#ffa7a7':'#e6cc75',}">
                      {{ item.qsInfo | eclipse }}
                    </div>
                    <img src="../../assets/images/move-icon.png" />
                    <span 
                      class="time"
                      :style="{
                        color: [undefined,null].includes(item.batch) ? '#ffa7a7':'#e6cc75',
                      }"
                    >日期：XXXX</span>
                  </div>
                  <el-button
                    v-show="[undefined,null].includes(item.batch)"
                    plain 
                    type="primary" 
                    size="mini" 
                    class="batch-settings"
                    @click.stop="batchChapCurr(item)"
                  >批量设置</el-button>
                </div>
                <template v-else>
                  <div
                    :class="{
                      'd-new': true,
                      'is-draging': cachetMove && currentIndex === item.cindex
                    }"
                  >
                    <a
                      @click="delChapter(item.cindex)"
                      href="javascript:void (0)"
                      class="el-icon-error color-danger del-chapter del-chapter__sign"
                    ></a>
                    <div
                      @mousedown.capture="
                        handleCacheMousedown($event, item.cindex)
                      "
                    >
                      <img
                        :src="item.url"
                        :data-cindex="item.cindex"
                        class="chapte-img"
                        :style="getSignSize(item)"
                      />
                      <img
                        v-if="currentIndex === item.cindex"
                        class="move"
                        src="../../assets/images/move-icon.png"
                      />
                    </div>
                  </div>
                </template>
              </template>
              <template v-if="!item.url && !isautomaticQian">
                <p
                  @click="$message.info('请在右侧选择签章')"
                  class="chapte-postion"
                >
                  签章位置
                </p>
              </template>
            </div>
          </template>
        </div>

        <!-- 隐藏左右切换按钮-->
        <template v-if="false">
          <div
            @click="handlePrePage"
            v-if="page > 1"
            ref="pre"
            class="pre"
            :style="{ left: `${preLeft}px` }"
          >
            <i class="el-icon-arrow-left"></i>
          </div>
          <div
            @click="handleNextPage"
            v-if="page < items"
            ref="next"
            :style="{ left: `${nextLeft ? nextLeft : ''}px` }"
            class="next"
          >
            <i class="el-icon-arrow-right"></i>
          </div>
        </template>
      </div>
    </div>
    <BatchSettingsPup 
      title="印章批量设置"
      :visible.sync="VISI"
      width="40%"
      :appendToBody="true"
      :VISI="VISI"
      :items="items"
      :BChapCurr="BChapCurr"
      :before-close="(done)=>{VISI =false;done()} "
      @BatchSettinsClose="BatchSettinsClose"
    ></BatchSettingsPup>
  </div>
</template>

<script>
import qs from "qs";
import { mapGetters } from "vuex";
import BatchSettingsPup from './components/BatchSettingsPup.vue';

export default {
  data() {
    return {
      VISI:false,
      BChapCurr:{},
      elBox: { width: 0, height: 0 },
      imgBox: { width: 0, height: 0 },
      imgOptions: { top: 0, left: 0 },
      smallBox: { width: 0, height: 0 },
      floatBox: { width: 0, height: 0 },
      floatOptions: { top: 0, left: 0 },
      showSmallBox: false,
      floatMove: false,
      // 当前用户选中拖拽的章的dom对象
      objCurrentCachet: null,
      cachetMove: false,
      currentIndex: null, // 当前拖动的item
      // 切换按钮位置
      preLeft: null,
      nextLeft: null,
      // 小地图 拖动相对位移
      deviationSmallMap: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        clientWidth: 0,
        clientHeight: 0
      },
      // 控制滚动加载上下页的开关，防止加载多次
      timerKg: true,
      // 加载loading
      imgLoading: true,
      // 拖动滚动变量
      pageX1: null,
      pageY1: null
    };
  },
  components:{BatchSettingsPup},
  props: {
    // 是否是创建合同
    isCreate: { type: Boolean, default: true },
    // 合同图信息
    contractInfo: { type: Object },
    // 合同图片
    url: { type: String, default: "" },
    // 签章列表
    chapterList: { type: Array },
    // 是否隐藏章
    showChapter: { type: Boolean, default: false },
    // 总页数
    items: { type: Number, default: 0 },
    // 当前页
    page: { type: Number, default: 1 },
    // 是否固定签署
    chapteFixed: { type: Boolean, default: false },
    // 是否自动签-自动签不显示签字位置
    isautomaticQian: { type: Boolean, default: false },
    // 是否是极简模式
    isHiddenHeader: { type: Number, default: 0 },
    // 缩放比例结合sync
    scaleValue: { type: Number, default: 100 }
  },
  computed:{
    ...mapGetters(['getConverScale']),
    currentUserType() {
      return this.$store.getters.currentAuthUser.userType;
    },
  },
  watch: {
    chapterList: {
      handler(val) {
        this.$emit("update:chapterList", val);
      },
      deep: true
    },
    contractInfo: {
      handler(val) {
        this.imgLoading = true;
        this.$emit("update:contractInfo", val);
      },
      deep: true
    },
    // 放大镜拖拽框位置设置
    floatOptions: {
      handler(val) {
        let objFloatBox = this.$el.querySelector(".float-box");

        this.imgOptions = {
          top:
            (-val.top / (this.smallBox.height - this.floatBox.height)) *
            (this.imgBox.height - this.elBox.height),
          left:
            (-val.left / (this.smallBox.width - this.floatBox.width)) *
            (this.imgBox.width - this.elBox.width)
        };

        objFloatBox.style.top = `${val.top}px`;
        objFloatBox.style.left = `${val.left}px`;

        let boxOffsetLeft = 0;
        let boxOffsetTop = 0;
        if (this.imgBox.width && this.imgBox.height) {
          boxOffsetLeft = Math.abs(this.$refs.contBox.offsetLeft);
          boxOffsetTop = Math.abs(this.$refs.contBox.offsetTop);
        }
        // 可视区宽高
        let clientWidth = 1000,
          clientHeight = 800;
        if (this.$refs.bigBox) {
          clientWidth = this.$refs.bigBox.clientWidth;
          clientHeight = this.$refs.bigBox.clientHeight;
          if (clientWidth >= this.imgBox.width) {
            clientWidth = this.imgBox.width;
          }
        }
        // zhoucheng 修改中心位置
        this.$emit("changeSmallMap", {
          left: boxOffsetLeft,
          top: boxOffsetTop,
          width: this.imgBox.width,
          height: this.imgBox.height,
          clientWidth: clientWidth,
          clientHeight: clientHeight
        });

        // 小地图 拖动相对位移
        this.deviationSmallMap.left = boxOffsetLeft;
        this.deviationSmallMap.top = boxOffsetTop;
        this.deviationSmallMap.width = this.imgBox.width;
        this.deviationSmallMap.height = this.imgBox.height;
        this.deviationSmallMap.clientWidth = clientWidth;
        this.deviationSmallMap.clientHeight = clientHeight;
      },
      deep: true
    },
    // 合同跟随放大镜拖拽框显示
    imgOptions: {
      handler(val) {
        let objContBox = this.$el.querySelector(".cont-box");

        objContBox.style.top = val.top + "px";
        objContBox.style.left = val.left + "px";
      },
      deep: true
    },
    url(newVal) {
      this.imgLoading = true;
    }
  },
  filters: {
    eclipse(value) {
      if (!value) return "";
      let maxNum = 23;
      value = value + "";
      return value.length > maxNum ? value.substr(0, maxNum) + "..." : value;
    }
  },
  mounted() {
    if (this.$refs.bigBox) {
      this.$refs.bigBox.addEventListener("scroll", () => {
        const scrollTop = this.$refs.bigBox.scrollTop;
        // 小地图 拖动相对位移
        this.deviationSmallMap.top = scrollTop;
        this.$emit("changeSmallMap", this.deviationSmallMap);
      });
    }
    this.scrollTurnPage();
  },
  methods: {
    /** 印章批量设置 */
    BatchSettinsClose({status,ApplyForm}){
      if(status === 'close') {this.VISI =false};
      if(status === 'submit'){
        // CUR 母印章数据；
        // pageMode 1 全部页面; 2 奇数页面; 3 偶数页面; 4 指定页面;
        const {desi,pageMode} = ApplyForm,CUR={...this.BChapCurr},
        pages = [...Array(this.items+1).keys()].slice(1);
        let CHAPLIST=[...this.chapterList];
        // 0. 如果存在已经批量设置的签章，清空已存在的批量签章【CHAPLIST】
        if('batch' in CUR){
          // 0.1 如果当前章存在【batch】属性，删除所有【batch】相同值的数据
          CHAPLIST = CHAPLIST.filter(chap=> chap.batch !== CUR.batch);
        }else{
          // 0.2 如果当前没有【batch】，删除当前章
          CHAPLIST = CHAPLIST.filter(chap=> chap.cindex !== CUR.cindex)
        }
        // 1.拆分出需要复制的签章页数
        let batchPage = [],batchChap = [];  
        switch (pageMode) {
          case '2':
            // 获取奇数
            batchPage = pages.filter(num => num % 2 !== 0);
            break;
          case '3':
            // 获取偶数
            batchPage = pages.filter(num => num % 2 === 0);
            break;
          case '4':
            // 获取指定的页数
            const pageArr = desi.replace(/[，,]/g, ',').split(','),result=[];
            for (let item of pageArr) {
              item = item.trim();
              if (item.includes('-')) {
                  // 处理区间，如 "4-6"
                  const [start, end] = item.split('-').map(Number);
                  for (let i = start; i <= end; i++) {
                      result.push(i);
                  }
              } else {
                  // 处理单个数字
                  result.push(Number(item));
              }
            };
            batchPage = [...new Set(result)].sort((a, b) => a - b)
            break;
          default:
            batchPage = pages;
            break;
        }
        // 2.构建出批量签章，并标识 batch 属性
        for (let i = 0; i < batchPage.length; i++) {
          if ((CHAPLIST.length + batchPage.length) >= 30) {
            this.$message({
              message: "温馨提示, 签章最大限制30个!",
              type: "warning"
            });
            break;
          }
          const elem = batchPage[i],start =CHAPLIST.length;
          batchChap.push({...CUR,page:elem - 1,batch:CUR.cindex,cindex:start+i,_ApplyForm:{...ApplyForm}})
        }
        // 3.将构建的批量签章push进入 chapterList 数组
        CHAPLIST.push(...batchChap);
        this.$emit("update:chapterList", CHAPLIST);
        this.VISI =false;
      }
    },
    /** 打开批量设置弹窗并记录当前印章 */
    batchChapCurr(item){
      this.BChapCurr=item;
      this.VISI = true;
    },
    /** 处理签章的尺寸 */
    getSignSize(sign){
      // 原签章【1714】需求前的签章大小 （40mm）
      // 加入 sign.imageHeight 的判断是签章页面有之前保存签章的情况，没有isEntSeal字段判断是否是企业签章；使用高度判断是否企业签章
      const isEnt = (sign.isEntSeal || (sign.imageHeight >= 200));
      if([7].includes(sign.sealLevel) || (!isEnt && [4].includes(sign.sealLevel)) ) return ''
      const signSize = {
        width:`${isEnt ? 202 : 115}`,
        height:`${parseInt(isEnt ? 224 : 79) - (parseInt(qs.parse(sign.url).timeStampSwitch ==1 ? 22 : 0))}`
      }
      /*
        带有宽高规格数据的签章等比例换算 （原签章大小像素值 / 原签章规格）* 签章规格参数值
        例如： 现在有一个 50mm * 50mm的签章, 可以得到 （180/40）* 50 px * (180/40) * 50 px 的签章
      */
      if(isEnt && sign.width){
        signSize.width=(signSize.width/this.getConverScale) * sign.width
        signSize.height =(signSize.height / this.getConverScale) * sign.height
      }
      //2025-11-24个人的方章尺寸遗漏的 补充
      if (this.currentUserType === 0 && sign.imageHeight === 100) {
        return {
          width: '100px',
          height: '100px',
        }
      }
      return {
        width:`${signSize.width}px`,
        height:`${signSize.height}px`
      }
    },
    /**
     * js根据节点名称，查找某节点的特定父节点
     * @className 父节点中含有当前class的节点
     * */
    getParentNode(node, className) {
      if (!node) return "";
      if (node.nodeName == "BODY") return node;
      let tnode = node.parentNode;
      let cName = tnode.getAttribute("class");
      if (cName === className) return tnode;
      return this.getParentNode(tnode, className);
    },
    /**
     * js根据节点名称，查找某节点的特定子节点
     * @className 子节点中含有当前class的节点
     * */
    getChildrenNode(node, className) {
      if (!node) return "";
      let tnode = node.children;
      if (!tnode || !tnode.length) return "";
      for (let i = 0; i < tnode.length; i++) {
        let item = tnode[i];
        let cName = item.getAttribute("class");
        if (cName === className) return item;
        let findNode = this.getChildrenNode(item, className);
        if (findNode) {
          return findNode;
        }
      }
      return "";
    },
    dropData(ev) {
      ev.preventDefault();
    },
    // 计算签章初始化位置
    handleSetChapte(chapte) {
      let { offsetX, offsetY, imageHeight,height } = chapte;
      if (!imageHeight) {
        // 固定章
        console.info("chapteFixed", this.chapteFixed);
        if (this.chapteFixed) {
          // 空章
          imageHeight = 64;
        } else {
          imageHeight = 48;
        }
      }
      if(height) imageHeight = (imageHeight / this.getConverScale) * height;
      let fy = 300,
        fx = 400;
      let realOffsetY = (this.deviationSmallMap.height * offsetY).toFixed(6);
      // fy = realOffsetY - imageHeight
      fy = realOffsetY - imageHeight < 0 ? 10 : realOffsetY - imageHeight;
      fx = (this.deviationSmallMap.width * offsetX).toFixed(6);
      // console.log(fx,this.deviationSmallMap.width, offsetX)
      return { top: fy + "px", left: fx + "px" };
    },
    // 上一页 点击方法
    handlePrePage(bool) {
      if (this.page > 1) {
        this.$emit("pre-page", this.page - 1);
        this.$refs["bigBox"].scrollTop = this.$refs["bigBox"].scrollHeight;
        console.log([this.$refs["bigBox"]]);
        bool && this.$emit("toCurrentPage", this.page - 1); // 定位当前页左侧目录的位置
      }
    },
    // 下一页合同 点击方法
    handleNextPage(bool) {
      if (this.page < this.items) {
        this.$emit("next-page", this.page + 1);
        this.$refs["bigBox"].scrollTop = 0;
        // 是否定位左侧目录
        bool && this.$emit("toCurrentPage", this.page + 1); // 定位当前页左侧目录的位置
      }
    },
    // 上滚动
    scrollUp(dom) {
      if (dom.scrollTop > 0) return;
      if (!this.timerKg) return;
      this.timerKg = false;
      setTimeout(() => {
        this.handlePrePage(true);
        this.timerKg = true;
      }, 100);
    },
    // 下滚动
    scrollDown(dom) {
      // 完全相等过于严谨，实际场景存在一定误差，会出现无法触发； 所以将这个误差值判定在 【5】以内
      if(!!(dom.scrollHeight - (dom.clientHeight + dom.scrollTop)  <= 5)){
        if (!this.timerKg) return;
        this.timerKg = false;
        setTimeout(() => {
          this.handleNextPage(true);
          this.timerKg = true;
        }, 100);
      }
    },
    // 鼠标滚动翻页
    scrollTurnPage() {
      let domS = this.$refs["bigBox"];
      let scrollFunc = e => {
        e = e || window.event;
        if (e.wheelDelta) {
          //判断浏览器IE，谷歌滑轮事件
          if (e.wheelDelta > 0) {
            //当滑轮向上滚动时
            // alert("滑轮向上滚动");
            this.scrollUp(domS);
          }
          if (e.wheelDelta < 0) {
            //当滑轮向下滚动时
            // alert("滑轮向下滚动");
            this.scrollDown(domS);
          }
        } else if (e.detail) {
          //Firefox滑轮事件
          if (e.detail > 0) {
            // 下
            this.scrollDown(domS);
          }
          if (e.detail < 0) {
            //当滑轮向上滚动时
            this.scrollUp(domS);
          }
        }
        // 小地图时禁止盒子滚动引起外部滚动条滚动
        if (this.showSmallBox) {
          if (e.preventDefault) {
            // Firefox
            e.preventDefault();
            e.stopPropagation();
          } else {
            // IE
            e.cancelBubble = true;
            e.returnValue = false;
          }
        }
      };
      //给页面绑定滑轮滚动事件
      if (domS.addEventListener) {
        //firefox
        domS.addEventListener("DOMMouseScroll", scrollFunc, false);
      }
      //滚动滑轮触发scrollFunc方法  //ie 谷歌
      domS.onmousewheel = scrollFunc;
    },
    // 合同加载完成，初始化界面
    handleImgLoad: function(el) {
      this.showSmallBox = false;
      this.imgLoading = false;
      el = el.target;
      let elementRect = document.body.getBoundingClientRect();
      // let imgEl = document.createElement('img')
      // imgEl.src = el.src
      let imgEl = el;

      let elWidth = elementRect.width - 560;
      // 计算左侧和右侧宽度
      let leftAsideDom = document.getElementsByClassName("aside-left")[0];
      let rightAsideDom = document.getElementsByClassName("aside-right")[0];
      if (leftAsideDom && leftAsideDom) {
        // 计算左右side的margin
        let computedLeftStyle = null;
        let computedRightStyle = null;
        //    兼容IE和火狐谷歌等的写法
        if (window.getComputedStyle) {
          computedLeftStyle = getComputedStyle(leftAsideDom, null);
          computedRightStyle = getComputedStyle(rightAsideDom, null);
        } else {
          computedLeftStyle = leftAsideDom.currentStyle; //兼容IE的写法
          computedRightStyle = rightAsideDom.currentStyle; //兼容IE的写法
        }
        let leftMr = computedLeftStyle.marginRight
          ? computedLeftStyle.marginRight.replace(/px|em|rem|%/, "")
          : 0;
        let rightMr = computedRightStyle.marginLeft
          ? computedRightStyle.marginLeft.replace(/px|em|rem|%/, "")
          : 0;
        elWidth =
          elementRect.width -
          leftAsideDom.clientWidth -
          rightAsideDom.clientWidth -
          leftMr -
          rightMr;
      }

      let bodyHeight = elementRect.height;
      // document.body.scrollHeight>bodyHeight && (bodyHeight=document.body.scrollHeight) // 高度处理，小屏幕能显示完全
      let elHeight = bodyHeight - 60;
      let headerY = document.querySelector(".y-header"); // 极简模式如果顶部高度
      if (this.isHiddenHeader == 1) {
        (!headerY || headerY.clientHeight == 0) && (elHeight = bodyHeight);
      }
      let bigBoxLeft = 0;
      let contBox = this.$el.querySelector(".cont-box");

      this.imgBox = {
        width: imgEl.naturalWidth || imgEl.width,
        height: imgEl.naturalHeight || imgEl.height
      };
      this.contractInfo["width"] = imgEl.naturalWidth || imgEl.width;
      this.contractInfo["height"] = imgEl.naturalHeight || imgEl.height;
      this.elBox = { width: elWidth, height: elHeight };
      // 20200721-取消上方小地图功能
      // 如果图片宽度大于合同容器宽度 把小地图加回来
      if (this.imgBox.width > elWidth && this.imgBox.width > 1100) {
        this.$el.querySelector('.big-box').setAttribute('style', `width: ${elWidth}px; height: ${elHeight}px;`)
        this.showSmallBox = true
        this.initSmallBox()
      } else
      if (this.imgBox.width < elWidth) {
        bigBoxLeft = (elWidth - this.imgBox.width) / 2;
      }

      this.$el.setAttribute(
        "style",
        `min-width: ${elWidth}px; height: ${elHeight}px`
      );
      // this.$el.querySelector('.cont-box').setAttribute('style', `width: ${this.imgBox.width}px; height: ${this.imgBox.height}px; left: ${bigBoxLeft}px`)
      this.$el
        .querySelector(".cont-box")
        .setAttribute(
          "style",
          `width: ${this.imgBox.width}px; height: ${this.imgBox.height}px;`
        );

      // 左右切换按钮位置
      if (this.imgBox.width > elWidth) {
        this.preLeft = contBox.getBoundingClientRect().left;
        this.nextLeft = contBox.getBoundingClientRect().left + elWidth - 40;
      } else {
        this.preLeft = contBox.getBoundingClientRect().left;
        this.nextLeft =
          contBox.getBoundingClientRect().left +
          contBox.getBoundingClientRect().width -
          40;
      }

      // 可视区宽高
      let clientWidth = 1000,
        clientHeight = 800;
      if (this.$refs.bigBox) {
        clientWidth = this.$refs.bigBox.clientWidth;
        clientHeight = this.$refs.bigBox.clientHeight;
        if (clientWidth >= this.imgBox.width) {
          clientWidth = this.imgBox.width;
        }
      }
      // zhoucheng 修改中心位置
      this.$emit("changeSmallMap", {
        left: 0,
        top: 0,
        width: this.imgBox.width,
        height: this.imgBox.height,
        clientWidth: clientWidth,
        clientHeight: clientHeight
      });
      // 小地图 拖动相对位移
      this.deviationSmallMap.width = this.imgBox.width;
      this.deviationSmallMap.height = this.imgBox.height;
      this.deviationSmallMap.clientWidth = clientWidth;
      this.deviationSmallMap.clientHeight = clientHeight;
    },
    /********* 签章拖拽效果 start ************/
    // 签章停止事件
    handleCacheStop: function(el) {
      if (this.chapteFixed) return;
      el.preventDefault();
      this.doCachetStop();
    },
    // 签章鼠标按下事件
    handleCacheMousedown: function(el, currentIndex) {
      if (this.chapteFixed) return;
      el.preventDefault();
      this.doCachetStart();
      this.currentIndex = currentIndex; // 记录当前拖动的第几项
      this.objCurrentCachet = this.getParentNode(el.target, "cachet-box"); // 获取move dom
      if (!this.objCurrentCachet) return;
      document.addEventListener("mousemove", this.handleCacheMousemove, false);
      document.addEventListener("mouseup", this.handleCacheStop, false);
    },
    // 签章随着鼠标移动事件
    handleCacheMousemove: function(el) {
      if (this.chapteFixed) return;
      el.preventDefault();
      if (!this.cachetMove && !this.objCurrentCachet) return;
      let {
        top: contBoxTop,
        left: contBoxLeft,
        width: contBoxW,
        height: contBoxH
      } = this.$el.querySelector(".cont-box").getBoundingClientRect();
      let { pageX: mouseX, pageY: mouseY } = el;
      let {
        width: caechetW,
        height: caechetH
      } = this.objCurrentCachet.getBoundingClientRect();

      let top = mouseY - contBoxTop - caechetH / 2;
      let left = mouseX - contBoxLeft - caechetW / 2;

      // 处理边界情况
      let boundaryValue = this.scaleToVal(35); // 合同的最小边界值

      if (top < boundaryValue) {
        top = boundaryValue;
      } else if (top > contBoxH - caechetH - boundaryValue) {
        top = contBoxH - caechetH - boundaryValue;
      }

      if (left < boundaryValue) {
        left = boundaryValue;
      } else if (left > contBoxW - caechetW - boundaryValue) {
        left = contBoxW - caechetW - boundaryValue;
      }

      // 加入缩放因子
      // console.log('加入缩放因子前的值',left,top)
      left = this.scaleToShow(left);
      top = this.scaleToShow(top);
      // console.log('加入缩放因子后的值',left,top)
      this.objCurrentCachet.style.top = `${top}px`;
      this.objCurrentCachet.style.left = `${left}px`;
    },

    // 签章停止移动
    doCachetStop: function() {
      const CURRCHAP = this.chapterList[this.currentIndex];
      this.cachetMove = false;
      document.removeEventListener(
        "mousemove",
        this.handleCacheMousemove,
        false
      );
      document.removeEventListener("mouseup", this.handleCacheStop, false);
      if (this.objCurrentCachet) {
        if (
          this.chapterList.length &&
          parseInt(this.objCurrentCachet.style.left) > 20 &&
          parseInt(this.objCurrentCachet.style.left) > 20
        ) {
          let cindex = this.objCurrentCachet.dataset.cindex;
          let rectInfo = this.objCurrentCachet.getBoundingClientRect();
          let y = 0;
          if (this.objCurrentCachet) {
            y =
              this.objCurrentCachet.height ||
              this.objCurrentCachet.clientHeight ||
              this.objCurrentCachet.naturalHeight;
          }
          let offX = parseFloat(
            (
              parseInt(this.objCurrentCachet.style.left) / this.imgBox.width
            ).toFixed(4)
          );
          let offY = parseFloat(
            (
              (parseInt(this.objCurrentCachet.style.top) + y) /
              this.imgBox.height
            ).toFixed(4)
          );
          this.chapterList.forEach(t => {
              /*
                这里需要判断拖动的签章是否批量签章
                如果是批量签章就将 batch 相同以及 batch === t.cindex的签章都更改位置
                如果不是批量签章就将cindex 相同以及 cindex === t.batch的签章都更改位置
              */  
              if(Object.keys(CURRCHAP).includes('batch')){
                // 当前更改的是批量设置印章，将当前印章以及batch相同记录的印章同步更改
                const BATCH = CURRCHAP.batch;
                if(BATCH === t.cindex || BATCH === t.batch){
                  t.offsetX = offX;
                  t.offsetY = offY;
                  t.imageHeight = y;
                }
              }else if(t.cindex == cindex || cindex == t.batch){
                // cindex 字段通过dataset导致类型变化，所以使用 == 而不使用全等
                // 如果不是批量签章就将cindex 相同以及 cindex === t.batch的签章都更改位置
                //  t.cindex == cindex 印章自身 以及批量签章也更改
                t.offsetX = offX;
                t.offsetY = offY;
                t.imageHeight = y;
              }
            });
        }
        this.objCurrentCachet = null;
        this.currentIndex = null;
      }
    },

    // 签章移动开始
    doCachetStart: function() {
      this.cachetMove = true;
    },
    /********* 签章拖拽效果 end ************/
    // 初始化放大镜，如果图片宽度大于合同显示的最大宽度
    initSmallBox() {
      this.$nextTick(() => {
        let percentW = this.elBox.width / this.imgBox.width;
        let percentH = this.elBox.height / this.imgBox.height;
        let smallRect = this.$el
          .querySelector(".small-box")
          .getBoundingClientRect();
        this.smallBox = { width: smallRect.width, height: smallRect.height };
        this.floatBox = {
          width: smallRect.width * percentW,
          height: smallRect.height * percentH
        };
        this.$el
          .querySelector(".float-box")
          .setAttribute(
            "style",
            `width: ${this.floatBox.width}px; height: ${this.floatBox.height}px; top: 0; left: 0;`
          );
      });
    },
    // 开启放大镜
    handleMoveMousedown: function(el) {
      el.preventDefault();
      this.doMoveStart();
      document.addEventListener("mousemove", this.handleMoveMousemove, false);
    },
    // 关闭放大镜
    handleMoveStop: function(el) {
      el.preventDefault();
      this.doMoveStop();
    },
    // 放大镜鼠标移动
    handleMoveMousemove: function(el) {
      if (!this.floatMove) return;
      el.preventDefault();
      let { left: smallX, top: smallY } = this.$el
        .querySelector(".small-box")
        .getBoundingClientRect();
      let { pageX: mouseX, pageY: mouseY } = el;
      let floatTop = mouseY - smallY - this.floatBox.height / 2;
      let floatLeft = mouseX - smallX - this.floatBox.width / 2;

      if (floatTop < 0) {
        floatTop = 0;
      } else if (floatTop > this.smallBox.height - this.floatBox.height) {
        floatTop = this.smallBox.height - this.floatBox.height;
      }

      if (floatLeft < 0) {
        floatLeft = 0;
      } else if (floatLeft > this.smallBox.width - this.floatBox.width) {
        floatLeft = this.smallBox.width - this.floatBox.width;
      }

      this.floatOptions = { top: floatTop, left: floatLeft };
    },
    doMoveStop: function() {
      this.floatMove = false;
      document.removeEventListener(
        "mousemove",
        this.handleMoveMousemove,
        false
      );
    },
    doMoveStart: function() {
      this.floatMove = true;
    },
    // 更具cindx删除签章
    delChapter(cindx) {
      this.$emit("del-chapte", cindx);
    },
    // 页面缩放后的值重新计算为页面真正的值
    scaleToShow(val) {
      return parseFloat(val) / (this.scaleValue / 100);
    },
    // 页面缩放-真实值计算为缩放后的值
    scaleToVal(val) {
      return parseFloat(val) * (this.scaleValue / 100);
    },
    // .............滑动页面 start..................
    pageMousedown(el) {
      el.preventDefault();
      let domScroll = document.getElementsByClassName("contract-view")[0];
      let imgDom = document.querySelector(".contract-view .imgInfo");
      this.pageX1 = el.pageX;
      this.pageY1 = el.pageY;
      if (
        el.target.className == "imgInfo" ||
        el.target.className == "contract-view" ||
        el.target.className == "big-box"
      ) {
        // if(parseInt(domScroll.parentNode.clientWidth) >= this.scaleToVal(imgDom.clientWidth)) return;
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          el.target.style.cursor = "pointer";
        } else {
          el.target.style.cursor = "grab";
        }
        domScroll.addEventListener("mousemove", this.pageMousemove, false);
        domScroll.addEventListener("mouseup", this.pageMouseStop, false);
      }
    },
    pageMousemove(e) {
      let max = this.scaleToVal(200); // 限制单次最大移动距离
      let domScroll = document.getElementsByClassName("contract-view")[0];
      let x1 = this.pageX1 - e.clientX;
      x1 = Math.abs(x1) > max ? (x1 >= 0 ? max : -max) : x1;
      let y1 = this.pageY1 - e.clientY;
      y1 = Math.abs(y1) > max ? (y1 >= 0 ? max : -max) : y1;
      domScroll.scrollLeft = domScroll.scrollLeft + Math.ceil(x1 / 30);
      domScroll.scrollTop = domScroll.scrollTop + Math.ceil(y1 / 30);
    },
    pageMouseStop(el) {
      let domScroll = document.getElementsByClassName("contract-view")[0];
      let imgDom = document.querySelector(".contract-view .imgInfo");
      imgDom && (imgDom.style.cursor = "default");
      domScroll.removeEventListener("mousemove", this.pageMousemove, false);
      domScroll.removeEventListener("mouseup", this.pageMouseStop, false);
    },
    pageLeave(el) {
      this.pageMouseStop();
    }
    // .............滑动页面 end..................
  },
  name: "contract-view"
};
</script>

<style lang="less" scoped>
@goPageHeight: 0;
.big-box {
  box-sizing: border-box;
  transform-origin: 0 0;

  .cont-box {
    /*position: absolute;*/
    position: relative;
    margin: 0 auto;
    box-sizing: border-box;
    top: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: #ffffff;

    .next,
    .pre {
      position: fixed;
      top: 40%;
      width: 40px;
      padding: 20px 0;
      background: rgba(0, 0, 0, 0.3);
      cursor: pointer;
      color: #fff;
      font-size: 40px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    img {
      vertical-align: top;
    }
  }

  .cachet-box {
    position: absolute;
    display: inline-block;
    box-sizing: border-box;
    top: 300px;
    left: 500px;
    cursor: move;
    .batch-settings{
      display: none;
    }
    &:hover{
      .batch-settings{
          display: inline-block;
          position: absolute;
          bottom: 5px;
          right: 5px;
      }
    }
  }

  .chapte-postion {
    box-sizing: border-box;
    width: 100px;
    height: 64px;
    text-align: center;
    line-height: 64px;
    background: rgba(0, 0, 0, 0.5);
    border: 2px dashed #fff;
    color: #fff;
    cursor: pointer;
  }

  .del-chapter {
    display: inline-block;
    font-size: 18px;
    position: absolute;
  }

  .del-chapter__create {
    left: -18px;
    top: calc(50% - 9px);
  }

  .del-chapter__sign {
    top: 0px;
    right: -18px;
    z-index: 50;
    color: #666666;
  }
}

.small-box {
  position: fixed;
  top: 120px;
  width: 140px;
  z-index: 20;
  opacity: 0.5;
  border: 1px solid #03af03;

  .float-box {
    position: absolute;
    box-sizing: border-box;
    top: 0;
    width: 30%;
    height: 30%;
    background: #ffffff;
    border: 1px dashed red;
    /*opacity: 0.5;*/
    cursor: move;
  }

  img {
    width: 100%;
    vertical-align: top;
    max-height: 195px;
  }
}

.contract-view {
  position: relative;
  vertical-align: top;
  /*width: 100%;*/
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  box-sizing: border-box;
  /deep/ .el-loading-mask {
    z-index: 10;
  }
}

.page-shwo {
  position: absolute;
  top: @goPageHeight;
  /*width: 100%;*/
  left: 0;
  right: 0;
  z-index: 10;
  padding: 16px 0;
}
.chapte-img {
  animation: chapteShow 1.3s ease-out;
}

// 新版样式
.qz-new {
  width: 110px;
  opacity: 1;
  // position: relative;
  h1 {
    height: 25px;
    background: #ffa7a7;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 25px;
    color: rgba(255, 255, 255, 1);
    padding-left: 5px;
    box-sizing: border-box;
    border-radius: 6px 6px 0px 0px;
    text-align: left;
    transition: all ease 0.2s;
  }
  .con {
    transition: all ease 0.2s;
    opacity: 0.7;
    font-size: 12px;
    text-align: center;
    position: relative;
    height: 85px;
    border: 1px solid rgba(236, 28, 28, 1);
    border-style: none dashed dashed dashed;
    box-sizing: border-box;
    padding: 18px 5px;
    border-radius: 0 0 10px 10px;
    background: #ffffff;
    text-overflow: ellipsis;
  }
  img {
    position: absolute;
    width: 15px;
    height: 15px;
    left: 50%;
    bottom: -8px;
    margin-left: -8px;
  }
  .del-chapter {
    position: absolute;
    top: -9px;
    right: -10px;
    color: #a1a1a1;
    z-index: 54;
  }

  .time {
    position: absolute;
    left: 4px;
    bottom: 2px;
    z-index: 2;
    font-size: 10px;
    color: rgba(236, 28, 28, 1);
  }
}

.draging {
  position: relative;
  z-index: 80;
  h1 {
    background: rgba(236, 28, 28, 1);
  }

  .con {
    opacity: 1;
  }
}

.d-new {
  position: relative;
  .del-chapter {
    color: #a1a1a1;
    top: -9px;
    right: -10px;
  }
}

.is-draging {
  &:after {
    position: absolute;
    top: -10px;
    bottom: -10px;
    right: -20px;
    left: -20px;
    /*padding: 10px 20px;*/
    content: " ";
    border: 1px dashed #ec1c1c;
    border-radius: 2px;
  }

  .del-chapter {
    top: -19px;
    right: -30px;
  }

  .move {
    position: absolute;
    width: 15px;
    height: 15px;
    left: -28px;
    top: 50%;
    margin-top: -8px;
  }
}

@keyframes chapteShow {
  from {
    transform: scale(1.3);
  }
  to {
    transform: scale(1);
  }
}

.slider-bar {
  position: fixed;
  z-index: 12;
  top: 68px;
  left: 3rem;
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// components/contract-view/indexOld.vue